<div class="pos-screen">

    <!-- TOP BAR -->
    <div class="pos-topbar">
        <div>
            <h2 class="pos-title">🧾 M. Siddique Steel</h2>
            <p class="pos-sub">Official Walking Customers Billing • Quick, Accurate & Reliable</p>
        </div>


        <div class="clock">{{ currentTime }}</div>
    </div>

    <div class="row g-4 mt-2">

        <!-- LEFT SIDE -->
        <div class="col-lg-8">

            <!-- MAIN FORM -->
            <form [formGroup]="saleForm" (ngSubmit)="submitSale()" class="pos-card">
                <div class="row">
                    <div class="col-md-6">
                        <!-- PRODUCT SEARCH BAR -->
                        <label class="pos-label">Select Product</label>
                        <div class="pos-search-bar shadow-sm">
                            <ng-select class="pos-search-select" [items]="products" bindLabel="productName"
                                placeholder="Scan barcode or search product..." [typeahead]="productInput$"
                                [virtualScroll]="true" [loading]="loading" (scrollToEnd)="scrollProducts()"
                                (change)="onProductSelected($event)">
                            </ng-select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label class="pos-label">Sale Date</label>
                        <div class="pos-search-bar shadow-sm">
                            <input type="date" class="form-control pos-input" formControlName="saleDate" />
                        </div>

                    </div>
                </div>

                <div class="divider my-4"></div>

                <!-- ITEMS TABLE -->
                <div class="table-responsive" *ngIf="items.controls.length > 0">
                    <table class="table pos-table table-borderless align-middle">

                        <thead>
                            <tr>
                                <th>Product</th>
                                <th width="90">Qty</th>
                                <th width="120">Rate</th>
                                <th width="90">Disc</th>
                                <th width="90">Tax</th>
                                <th>Total</th>
                                <th width="50"></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let item of items.controls; let i=index" [formGroup]="item">

                                <td class="prod-name">{{ item.value.productName }}</td>

                                <td><input type="number" formControlName="quantity" class="form-control pos-input-sm"
                                        (input)="updateTotals()"></td>

                                <td><input type="number" formControlName="unitPrice" class="form-control pos-input-sm"
                                        (input)="updateTotals()"></td>

                                <td><input type="number" formControlName="discount" class="form-control pos-input-sm"
                                        (input)="updateTotals()"></td>

                                <td><input type="number" formControlName="tax" class="form-control pos-input-sm"
                                        (input)="updateTotals()"></td>

                                <td class="fw-bold total-cell">{{ item.value.total | number:'1.0-0' }}</td>

                                <td>
                                    <button class="btn del-btn" type="button" (click)="removeItem(i)">
                                        <i class="bi bi-trash"></i>
                                    </button>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- EXPENSES -->
                <h5 class="section-head mt-4">Extra Charges</h5>
                <div class="row g-3">
                    <div class="col-md-4">
                        <label class="pos-label">Labour</label>
                        <input type="number" class="form-control pos-input" formControlName="labourExpense"
                            (input)="updateTotals()" />
                    </div>
                    <div class="col-md-4">
                        <label class="pos-label">Other</label>
                        <input type="number" class="form-control pos-input" formControlName="otherExpense"
                            (input)="updateTotals()" />
                    </div>
                    <div class="col-md-4">
                        <label class="pos-label">Freight</label>
                        <input type="number" class="form-control pos-input" formControlName="freightExpense"
                            (input)="updateTotals()" />
                    </div>
                </div>

                <!-- PAYMENTS -->
                <h5 class="section-head mt-4">Payments</h5>

                <div class="payment-row" *ngFor="let payment of payments.controls; let i=index" [formGroup]="payment">

                    <select class="form-select pos-input-sm" formControlName="paymentStatus">
                        <option value="unpaid">Unpaid</option>
                        <option value="partial">Partial</option>
                        <option value="paid">Paid</option>
                    </select>

                    <input type="number" class="form-control pos-input-sm" formControlName="amount" placeholder="Amount"
                        (input)="updateTotals()">

                    <select class="form-select pos-input-sm" formControlName="method">
                        <option value="cash">Cash</option>
                        <option value="bank">Bank</option>
                        <option value="easyPaisa">EasyPaisa</option>
                        <option value="jazzCash">JazzCash</option>
                        <option value="online">Online</option>
                        <option value="credit">Credit</option>
                    </select>

                    <input type="text" class="form-control pos-input-sm" placeholder="Note" formControlName="note">

                    <button class="btn del-btn-sm" type="button" (click)="removePayment(i)">
                        <i class="bi bi-x-lg"></i>
                    </button>
                </div>

                <button type="button" class="btn add-btn mt-2" (click)="addPayment()">
                    <i class="bi bi-plus-circle"></i> Add Payment
                </button>

                <!-- SAVE BUTTON -->
                <button type="submit" class="btn save-btn w-100 mt-3">
                    Save Sale
                </button>

            </form>

        </div>

        <!-- RIGHT SUMMARY -->
        <div class="col-lg-4">
            <div class="summary-card shadow-lg">

                <!-- HEADER -->
                <div class="text-center mb-3 pb-2 border-bottom">
                    <!-- Logo -->
                    <img src="/assets/images/mlogo2.png" alt="Company Logo"
                        style="width: 80px; height: auto; display: block; margin: 0 auto 8px;">

                    <!-- Company Name -->
                    <h5 class="fw-bold text-primary mb-1">M. Siddique Steel</h5>

                    <!-- Contact Info / CTA -->
                    <p class="small mb-0">
                        <strong>Email:</strong> info&#64;msiddiquesteel.com |
                        <strong>Phone:</strong> +92 334 1234567
                    </p>
                </div>


                <!-- SALE DATE -->
                <div class="summary-row">
                    <span>Sale Date</span>
                    <span class="value">{{ saleForm.value.saleDate | date:'mediumDate' }}</span>
                </div>

                <!-- PRODUCTS Subtotal -->
                <div class="summary-row">
                    <span>Products Subtotal</span>
                    <span class="value">{{ saleForm.value.subTotal | number:'1.0-0' }}</span>
                </div>

                <!-- IMPRESS PRODUCT DETAILS -->
                <div class="impress-products mt-3" *ngIf="items.controls.length > 0">
                    <h6 class="mb-2">Selected Products</h6>
                    <div *ngFor="let item of items.controls" class="product-summary-row">
                        <div><strong>Name:</strong> {{ item.value.productName }}</div>
                        <div><strong>Qty:</strong> {{ item.value.quantity }}</div>
                        <div><strong>Unit Rate:</strong> {{ item.value.unitPrice | number:'1.0-0' }}</div>
                        <div><strong>Discount:</strong> {{ item.value.discount || 0 }}%</div>
                        <div><strong>Tax:</strong> {{ item.value.tax || 0 }}%</div>
                        <hr />
                    </div>
                </div>

                <!-- Expenses -->
                <div *ngIf="saleForm.value.labourExpense > 0" class="summary-row">
                    <span>Labour Charges</span>
                    <span class="value">{{ saleForm.value.labourExpense | number:'1.0-0' }}</span>
                </div>
                <div *ngIf="saleForm.value.otherExpense > 0" class="summary-row">
                    <span>Other Charges</span>
                    <span class="value">{{ saleForm.value.otherExpense | number:'1.0-0' }}</span>
                </div>
                <div *ngIf="saleForm.value.freightExpense > 0" class="summary-row">
                    <span>Freight Charges</span>
                    <span class="value">{{ saleForm.value.freightExpense | number:'1.0-0' }}</span>
                </div>

                <hr>

                <!-- Paid -->
                <div class="summary-row">
                    <span>Paid</span>
                    <span class="value">{{ saleForm.value.totalPaid | number:'1.0-0' }}</span>
                </div>

                <!-- Remaining -->
                <div class="summary-row text-danger fw-bold">
                    <span>Remaining</span>
                    <span class="value">{{ saleForm.value.remainingBalance | number:'1.0-0' }}</span>
                </div>

                <hr>

                <!-- Grand Total -->
                <div class="summary-grand">
                    <span>Grand Total</span>
                    <span>{{ saleForm.value.grandTotal | number:'1.0-0' }}</span>
                </div>

                <!-- FOOTER -->
                <div class="border-top mt-4 pt-2 text-center small text-muted fst-italic">
                    This is a system-generated bill. No signature required. Thank you for your business!
                    <p class="mb-0">
                        <strong>M. Siddique Steel</strong>
                    </p>
                </div>

            </div>
        </div>





    </div>

</div>